import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogRef } from '@angular/material/dialog';
import { SessionTimeoutService } from '@core/service/session-timeout.service';
import { environment } from '@env/environment';

@Component({
  selector: 'app-idle-warning-timer',
  templateUrl: './idle-warning-timer.component.html',
  styleUrl: './idle-warning-timer.component.scss',
  standalone: true,
  imports: [
    MatCardModule,
    MatButtonModule
  ]
})
export class IdleWarningTimerComponent {
  private _sessionTimeoutService = inject(SessionTimeoutService);

  private _dialogRef = inject(MatDialogRef<IdleWarningTimerComponent>);
  
  countdown = environment.idle_timeout;
  idleState;

  constructor() {
    this.calculateIdleState();
  }

  calculateIdleState() {
    setInterval(() => {
      this.idleState = Math.floor(this.countdown / 60)+' mins  '+this.countdown%60+' sec'
      this.countdown -= 1;
    }, 1000);
  }

  stay() {
    this._sessionTimeoutService.stopWatching();
    this._sessionTimeoutService.stopWarningTimer();

    const logoutTime = this._sessionTimeoutService.logoutTime;
    this._sessionTimeoutService.startWatching(logoutTime * 1000);

    this.closeDialog();
  }

  logout() {
    this._sessionTimeoutService.logout();
    this.closeDialog();
  }

  closeDialog() {
    this._dialogRef.close();
  }
}
